import React from "react";


export function SectionFeatures() {
  return(
      <div className="container">
        <h5> I'm Features </h5>
      </div>
  )
}
